import React, { PureComponent } from 'react';

import { Button, Icon, Labeled, Select } from 'components/ClubComponents';
import { I18n, translate } from 'components/translate';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { toJS } from 'mobx';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

import { getSummaryOfSelectedPagesAndModules } from '../helpers';

import './CommentListHeaderContentSelect.scss';

@inject((stores) => ({
  modulesList: toJS(stores.ContentStore.modulesList),
  modulesExtraList: toJS(stores.ContentStore.modulesExtraList)
}))
@translate()
class CommentListHeaderContentSelect extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.array,
    modulesList: PropTypes.array,
    modulesExtraList: PropTypes.array
  };

  constructor(props) {
    super(props);

    const { value } = props;

    this.state = {
      value,
      modules: []
    };

    this.unmounted = false;
    this.setup();
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        value: toJS(this.props.value)
      });
    }
  }

  setup() {
    const { t } = this.props;

    this.ADAPTER = {
      getID: (item) => {
        let id = '';

        /**
         * Here we use the compound [MODULE_ID/]ID, since we have faced
         * the utterly unlucky scenario where there was a
         * module and a page with the same ID.
         */
        if (item.moduleId) {
          id = `${item.moduleId}/`;
        }

        id = `${id}${item.id}`;

        return id;
      },
      getLabel: (item) => item.name,
      getChildren: (item) => item.pages,
      renderOption: (item) => {
        const label = item.name;

        if (!isNil(item.pages)) {
          return label;
        }

        return (
          <React.Fragment>
            <Icon className="page-item__icon" name="file-document" size={16} />
            <span className="page-item__label">{label}</span>
          </React.Fragment>
        );
      },
      renderValue: ({ value }) => {
        if (isNil(value) || isEmpty(value)) {
          return null;
        }

        return getSummaryOfSelectedPagesAndModules(t, value);
      }
    };

    this.SEARCHABLE = {
      placeholder: t('community.search_pages_and_modules_placeholder')
    };
  }

  handleClear = () => {
    const { onChange } = this.props;

    onChange && onChange([]);
  };

  handleFilter = (toggle, value) => () => {
    const { onChange } = this.props;

    if (!onChange) {
      return;
    }

    onChange(value);
    toggle();
  };

  renderToggle = ({ disabled, onClear, onToggle, open }) => {
    const { value } = this.props;

    return (
      <Select.Toggle
        open={open}
        clearable={!isEmpty(value)}
        disabled={disabled}
        onClear={onClear}
        onToggle={onToggle}
      >
        {this.renderValue()}
      </Select.Toggle>
    );
  };

  renderFooter = ({ toggle, value }) => {
    return (
      <div className="footer">
        <Button
          data-test="c-comment-filter-btn-filter-m-and-p"
          onClick={this.handleFilter(toggle, value)}
          className="c-comment-filter-btn-footer"
        >
          <I18n label="general.filter" />
        </Button>
      </div>
    );
  };

  renderValue = () => {
    const { value } = this.props;

    if (isNil(value) || isEmpty(value)) {
      return <I18n label="community.select_pages_and_modules" />;
    }

    return this.ADAPTER.renderValue({ value });
  };

  render() {
    const { value } = this.state;
    const { modulesList, modulesExtraList } = this.props;

    const allModules = modulesList.concat(modulesExtraList);

    return (
      <Labeled
        data-test="c-comment-filter-m-and-p"
        mode="small"
        label={<I18n label="community.search_pages_and_modules" />}
        className="comment-list__filter__type"
      >
        <Select
          clearable
          searchable={this.SEARCHABLE}
          multiple
          toggle={this.renderToggle}
          options={allModules}
          onClear={this.handleClear}
          value={value}
          footer={this.renderFooter}
          adapter={this.ADAPTER}
        />
      </Labeled>
    );
  }
}

export default CommentListHeaderContentSelect;
